import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { BDProductCategory } from '@brother-apps/brother-dealerapp-shared-lib';

@Component({
    selector: 'bdcp-product-product-root',
    templateUrl: './root.page.html',
    styleUrls: ['./root.page.scss']
})
export class BDCPProductFinderRootComponent implements OnInit {

    public productCategories: BDProductCategory[];

    public constructor(
        private router: Router,
        private route: ActivatedRoute
    ) { }

    public ngOnInit(): void {
        this.productCategories = [];

        this.productCategories.push(this.getCategory('Scanner', 'scanner', 'assets/images/Kategorie-Bild_Scanner ADS4_CG_Images_4900W_front_reflection.png'));
        this.productCategories.push(this.getCategory('Drucker', 'printer', 'assets/images/Kategorie-Bild-Drucken_PRT2_HL-L9470CDN_front_reflection.png'));
        this.productCategories.push(this.getCategory('Multifunktionsgeräte', 'mfc', 'assets/images/Kategorie-Bild-Multifunktionsgerate_MFC-J6957DW_front.png'));
        this.productCategories.push(this.getCategory('Beschriftungsgeräte', 'labeler', 'assets/images/Beschriftung_PT-D610BT_Front.png'));
        this.productCategories.push(this.getCategory('Faxgeräte', 'fax', 'assets/images/cat_img-faxen.png'));
        this.productCategories.push(this.getCategory('Sonstige Geräte', 'other', 'assets/images/Kategorie-Bild_Sonstige Gerate_HAK_34R_CO.png'));
        this.productCategories.push(this.getCategory('Verbrauchsmaterial', 'supply', 'assets/images/cat_img-verbrauchsmaterial.png'));
        this.productCategories.push(this.getCategory('Zubehör', 'accessory', 'assets/images/cat_img-zubehoer.png'));
    }

    public search(category: BDProductCategory): void {
        this.router.navigate(['category', category.internalName], { relativeTo: this.route });
    }

    private getCategory(name: string, internalName: string, imageSource: string): BDProductCategory {
        const productCategory = new BDProductCategory();

        productCategory.name = name;
        productCategory.internalName = internalName;
        productCategory.imageSource = imageSource;

        return productCategory;
    }
}
